"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const PublishersStep_1 = __importDefault(require("@App/kit/scenes/WorkScenes/Steps/PublishersSteps/PublishersStep"));
const contexts_1 = require("@App/contexts");
const fetch_type_enum_1 = require("@Components/WorkItemV2/fetch-type-enum");
const react_router_dom_1 = require("react-router-dom");
const analytics_utils_1 = require("@App/common/utils/analytics-utils");
const ClaimSearch_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Claim/ClaimSearch"));
const common_1 = require("@Const/common");
const WizardFlow_1 = __importDefault(require("@Components/WizardFlow"));
const ClaimWizardNavigationBar_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/ClaimWizardFlow/ClaimWizardNavigationBar"));
const ReviewWorkFormScene_1 = __importDefault(require("@Scenes/WorkScenes/ReviewWorkFormScene"));
const ClaimSubmissionStep_1 = __importDefault(require("@Scenes/WorkScenes/Steps/ClaimSubmissionStep"));
const ClaimWizardFlow = () => {
    const { wizardFlowStore, workStore, claimToolStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const location = (0, react_router_dom_1.useLocation)();
    const selectWork = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (!workStore.workById || workStore.workById.id !== id) {
            yield workStore.getWorkById(id, fetch_type_enum_1.FetchType.HFA);
        }
        const workDetails = workStore.workById;
        if (workDetails) {
            workDetails.alternativeTitles = [];
            workDetails.recordings = [];
            workStore.setWorkDraftToLocal(workDetails);
        }
        wizardFlowStore.advanceIndex();
    });
    // Passing in a propertyId via location state when redirecting to claiming tool allows you to skip step 1
    // and go right into the claiming of a specified work
    const checkForProvidedWorkOverride = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.propertyId) {
            preloaderStore.openMainPreloader(true);
            yield selectWork((_b = location.state) === null || _b === void 0 ? void 0 : _b.propertyId);
            preloaderStore.openMainPreloader(false);
        }
    });
    (0, react_1.useEffect)(() => {
        (0, analytics_utils_1.analyticsSendPage)('claim');
        checkForProvidedWorkOverride();
        return () => claimToolStore.resetClaimingToolWizard();
    }, []);
    const flow = [
        {
            stepIndicator: {
                icon: common_1.ICONS.search,
                label: 'Search',
            },
            forms: [react_1.default.createElement(ClaimSearch_1.default, { key: 'claim-search-step', selectWork: selectWork })],
            navigationBar: react_1.default.createElement(ClaimWizardNavigationBar_1.default, null),
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.publishers,
                label: 'Add Publishers & Shares',
            },
            forms: [react_1.default.createElement(PublishersStep_1.default, { workType: 'claim-wizard', key: 'claim-publishers-step' })],
            navigationBar: react_1.default.createElement(ClaimWizardNavigationBar_1.default, null),
            onNextValidation: () => claimToolStore.onNextValidatePublishers() && workStore.onNextValidateOverclaim(),
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.workDetails,
                label: 'Review',
            },
            forms: [react_1.default.createElement(ReviewWorkFormScene_1.default, { workType: 'claim-wizard', key: 'claim-edit-work-scene' })],
            navigationBar: react_1.default.createElement(ClaimWizardNavigationBar_1.default, null),
            onNextValidation: () => workStore.onNextValidateOverclaim(),
        },
        {
            stepIndicator: {
                icon: common_1.ICONS.upload,
                label: 'Submit',
                displayFinishedIconAction: 'on',
            },
            forms: [react_1.default.createElement(ClaimSubmissionStep_1.default, { key: 'claim-submission-step' })],
            navigationBar: react_1.default.createElement(ClaimWizardNavigationBar_1.default, null),
        },
    ];
    wizardFlowStore.setFlow(flow);
    return react_1.default.createElement(WizardFlow_1.default, { heading: 'Claiming Tool' });
};
exports.default = (0, mobx_react_1.observer)(ClaimWizardFlow);
